// Story 10.2 — Toolbar del dashboard: search + sort. Estado en URL search
// params (`?q=&sort=`) — controlado vía props callback.

import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { SortKey } from '@/lib/bots-filter';

interface Props {
  query: string;
  sort: SortKey;
  onQueryChange(value: string): void;
  onSortChange(value: SortKey): void;
}

export function BotsToolbar({
  query,
  sort,
  onQueryChange,
  onSortChange,
}: Props): React.ReactElement {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="relative md:w-80">
        <Search
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
          aria-hidden
        />
        <Input
          type="search"
          aria-label="Buscar bots por nombre"
          placeholder="Buscar por nombre…"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          className="pl-9"
        />
      </div>
      <div className="flex items-center gap-2">
        <Label htmlFor="bots-sort" className="text-xs uppercase text-muted-foreground">
          Ordenar
        </Label>
        <select
          id="bots-sort"
          value={sort}
          onChange={(e) => onSortChange(e.target.value as SortKey)}
          className="h-9 rounded-md border border-input bg-background px-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <option value="activity">Última actividad</option>
          <option value="name">Nombre</option>
          <option value="status">Estado</option>
        </select>
      </div>
    </div>
  );
}
